export enum MapType {
    WGS84 = 'WGS84',
    UTM33N = 'UTM33N',
}

export enum RegionSetting {
    Norway = 'Norway',
    Europe = 'Europe',
}